"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcChip = function DxcChip(_ref) {
  var label = _ref.label,
      suffixIcon = _ref.suffixIcon,
      prefixIcon = _ref.prefixIcon,
      onClickSuffix = _ref.onClickSuffix,
      onClickPrefix = _ref.onClickPrefix,
      disabled = _ref.disabled,
      margin = _ref.margin,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.chip
  }, /*#__PURE__*/_react["default"].createElement(StyledDxcChip, {
    disabled: disabled,
    margin: margin
  }, prefixIcon && /*#__PURE__*/_react["default"].createElement(IconContainer, {
    disabled: disabled,
    prefixIcon: true,
    label: label,
    mode: "prefix",
    tabIndex: typeof onClickPrefix === "function" && !disabled ? tabIndex : -1,
    onClick: function onClick() {
      return onClickPrefix && !disabled && onClickPrefix();
    },
    interactuable: typeof onClickPrefix === "function" && !disabled
  }, typeof prefixIcon === "string" ? /*#__PURE__*/_react["default"].createElement(PrefixIconContainer, {
    src: prefixIcon
  }) : prefixIcon), label && /*#__PURE__*/_react["default"].createElement(ChipTextContainer, {
    disabled: disabled
  }, label), suffixIcon && /*#__PURE__*/_react["default"].createElement(IconContainer, {
    disabled: disabled,
    suffixIcon: true,
    mode: "suffix",
    label: label,
    tabIndex: typeof onClickSuffix === "function" && !disabled ? tabIndex : -1,
    onClick: function onClick() {
      return onClickSuffix && !disabled && onClickSuffix();
    },
    interactuable: typeof onClickSuffix === "function" && !disabled
  }, typeof suffixIcon === "string" ? /*#__PURE__*/_react["default"].createElement(SuffixIconContainer, {
    src: suffixIcon
  }) : suffixIcon)));
};

var getCursor = function getCursor(interactuable, disabled) {
  if (disabled) {
    return "cursor:not-allowed;";
  }

  if (interactuable) {
    return "cursor:pointer;";
  }

  return "cursor:default; outline:none;";
};

var StyledDxcChip = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: center;\n  min-height: 40px;\n  max-width: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  cursor: ", ";\n"])), function (_ref2) {
  var margin = _ref2.margin;
  return "calc(100% - 40px - ".concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")");
}, function (props) {
  return props.disabled && props.theme.disabledBackgroundColor || props.theme.backgroundColor;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderThickness;
}, function (props) {
  return props.theme.borderStyle;
}, function (props) {
  return props.theme.borderColor;
}, function (props) {
  return props.theme.contentPaddingTop;
}, function (props) {
  return props.theme.contentPaddingBottom;
}, function (props) {
  return props.theme.contentPaddingLeft;
}, function (props) {
  return props.theme.contentPaddingRight;
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && "not-allowed";
});

var ChipTextContainer = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n  cursor: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])), function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.theme.fontStyle;
}, function (props) {
  return props.disabled ? props.theme.disabledFontColor : props.theme.fontColor;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && "not-allowed" || "default";
});

var SuffixIconContainer = _styledComponents["default"].img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])([""])));

var PrefixIconContainer = _styledComponents["default"].img(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])([""])));

var IconContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  ", "\n  ", "\n  width: ", ";\n  height: ", ";\n  overflow: hidden;\n\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n  &:focus {\n    outline-color: ", ";\n    outline-width: 2px;\n    ", "\n  }\n"])), function (props) {
  return props.disabled ? props.theme.disabledIconColor : props.theme.iconColor;
}, function (props) {
  return props.prefixIcon ? "margin-right: ".concat((props.label || props.suffixIcon) && props.theme.iconSpacing || props.prefixIcon && "0", ";") : "margin-left: ".concat((props.label || props.prefixIcon) && props.theme.iconSpacing || props.prefixIcon && "0", ";");
}, function (props) {
  return getCursor(props.interactuable, props.disabled);
}, function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.focusColor;
}, function (props) {
  return props.disabled && "outline: none;";
});

var _default = DxcChip;
exports["default"] = _default;